const LessonsContent = [
  {
    lessonsId: 1,
    subLessonsId: 1,
    name: 'Hello, world!',
    description: 'Cetak "Hello, world!" ke konsol',
    content: `
      Selamat datang di Blocode!<br>
      Untuk memulai, pastikan kamu terbiasa terlebih dahulu dengan lingkungan Blocode ini.<br><br>
      
      <div class="flex align-items-center mt-1 mb-1">
        <div class="image-fit">
          <img src="/images/toolbox.jpg"/>
        </div>
        <p class="ml-1">
          Di sisi kiri layar, kamu akan menemukan <b><i>toolbox</i></b> yang berisi blok-blok yang dapat digunakan untuk menyelesaikan
          sebuah permasalahan.<br><br>
          
          Kamu dapat meletakkan dan menyusun blok-blok tersebut ke tengah layar, yang akan kita sebut sebagai <b>kanvas</b>.    
        </p>
      </div>
      <br>
      <div class="flex align-items-center mt-1 mb-1">
        <p class="mr-1">
          Di bagian kanan layar, terdapat dua tombol, yaitu <b>Buka konsol</b> dan <b>Uji kode</b>.<br><br>
          
          <b>Konsol</b> digunakan untuk mengeksekusi blok-blok yang berada di kanvas. Gunakan konsol ini untuk menguji
          apakah alur program sudah sesuai dengan keinginan, dengan cara menjalankan langsung ataupun dieksekusi per blok.
        </p>
        <div class="image-fit">
          <img src="/images/console.jpg"/>
        </div>
      </div>
      <br>
      Bila program sudah sesuai, maka klik tombol "<b>Uji kode</b>" untuk menilai ketepatan program.<br><br>
      
      Kali ini, kamu diminta untuk mencetak "<b>Hello, world!</b>" ke konsol. Gunakan blok yang tepat lalu klik tombol "Uji kode" untuk
      menyelesaikan <i>lesson</i> ini dan lanjut ke <i>lesson</i> berikutnya!
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Matematika" colour="230">
          <label text="Angka" web-class="toolbox-label"/>
          <block type="math_number"></block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
        </category>
      </xml>
    `,
    testCase: [
      {
        input: [],
        output: ['Hello, world!']
      },
    ]
  },
  {
    lessonsId: 1,
    subLessonsId: 2,
    name: 'Masukan dan Keluaran',
    description: 'Terima masukan dan cetak ke konsol bersama kata "Tercetak!"',
    content: `
      Di kategori <b>Teks</b> terdapat sebuah blok "<b>prompt</b>" baru yang dapat digunakan untuk meminta nilai dari pengguna.<br>
      <div class="text-center">
        <img class="image-fit" src="/images/prompt-block.jpg"/>
      </div>
      <br>
      Kali ini kamu diminta untuk menerima teks dari pengguna dan mencetaknya ke konsol.<br>
      Kamu dapat menggunakan blok <b>print</b> yang mencetak sebuah blok <b>prompt</b>,
      yaitu dengan menaruh blok <i>prompt</i> di dalam blok <i>print</i> tersebut.<br>
      <div class="text-center">
        <img class="image-fit" src="/images/prompt-and-print-block.jpg"/>
      </div><br>
      
      Sebagai tantangan tambahan, tepat setelah mencetak teks masukan, cetaklah juga kata "<b>Tercetak!</b>".
      Untuk melakukannya, kamu cukup pasang blok <b>print</b> baru di bawah blok <i>print</i> lainnya.<br>
      <div class="text-center">
        <img class="image-fit" src="/images/print-blocks.jpg"/>
      </div><br>
      
      <b>Contoh: </b>Misalnya pengguna memberi masukan <code>Halo!</code>, maka di konsol akan tercetak
      <p>
        <code>
          Halo!<br>
          Tercetak!
        </code>
      </p><br>
      
      Cek hasil program kamu menggunakan konsol, dan jika sudah sesuai klik "Uji kode" untuk menilai!
    `,
    toolbox: `
       <xml id="toolbox" style="display: none">
        <category name="Matematika" colour="230">
          <label text="Angka" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
      </xml>
    `,
    testCase: [
      {
        input: ['Testestest123'],
        output: ['Testestest123', 'Tercetak!']
      },
      {
        input: ['aieou'],
        output: ['aieou', 'Tercetak!']
      },
    ]
  },
  {
    lessonsId: 2,
    subLessonsId: 1,
    name: 'Introduksi ke Variabel',
    description: 'Simpan masukan ke variabel dan cetak ke layar',
    content: `
      Sekarang adalah waktu yang tepat untuk memperkenalkan <b>variabel.</b><br><br>
      Variabel adalah sebuah penampung nilai yang dapat berisi apapun. Jadi kita bisa atur isi variabel ini sesuka hati.<br>
      Variabel ini juga sangat cocok untuk menyimpan nilai yang dimasukkan oleh pengguna.<br><br>
      
      Berikut tata cara memasang nilai dari pengguna ke sebuah variabel.
      <ol>
        <li>Buat variabel baru dengan mengklik <b>Variabel > Buat variabel...</b> lalu ketik nama variabel (bebas).</li>
        <li>
        Akan muncul blok <b>set</b>, <b>change</b>, dan <b>isi dari variabel</b> (sesuai nama yang dimasukkan tadi). 
        Geser blok <b>set</b> ke kanvas untuk mengatur nilai variabel.
        </li>
        <li>Pasang blok <b>prompt</b> ke dalam blok <b>set</b> untuk mengatur isi variabel sesuai dengan hasil dari <i>prompt</i>.</li>
      </ol>
      <b>Hasilnya:</b> Blok <img src="/images/variable.jpg"/> akan berisi nilai teks <code>aiueo</code> ketika pengguna memasukkan "aiueo"<br><br>
      Setelah nilai berhasil dimasukkan ke dalam> variabel, kamu dapat mencetak isi dari variabel tersebut dengan menggunakan blok <b>print</b>.<br>
      <div class="text-center"><img src="/images/print-variable.jpg"/></div><br><br>
      Cobalah!
    `,
    toolbox: `
       <xml id="toolbox" style="display: none">
        <category name="Matematika" colour="230">
          <label text="Angka" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      {
        input: ['Testestest123'],
        output: ['Testestest123']
      },
    ]
  },
  {
    lessonsId: 2,
    subLessonsId: 2,
    name: 'Ekspresi Matematika',
    description: 'Terima dua buah masukkan dan cetak hasil penjumlahannya',
    content: `
      Sekarang kamu membutuhkan dua buah variabel untuk menyimpan dua buah nilai hasil masukkan pengguna.<br><br>
      
      Cetaklah hasil penjumlahan dari dua angka masukkan pengguna.<br>
      Gunakan blok <b>prompt</b> untuk meminta masukkan. <b>Jangan lupa untuk mengubah tipe masukkan menjadi "number".</b>
      <div class="text-center"><img src="/images/prompt-block-2.jpg"/></div><br><br>
      
      <h2>Tips</h2>
      Kamu dapat melakukan penjumlahan dua variabel dengan menggunakan blok <b>operator</b> di kategori <b>Matematika</b>.<br>
      <div class="text-center"><img src="/images/math-operation.jpg"/></div><br>
      Setelah itu, masukkan ekspresi penjumlahan tersebut ke dalam blok print.
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Matematika" colour="230">
          <label text="Angka" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      {
        input: [2, 3],
        output: [5]
      },
      {
        input: [10, 8],
        output: [18]
      },
      {
        input: [-3, 6],
        output: [3]
      },
    ]
  },
  {
    lessonsId: 2,
    subLessonsId: 3,
    name: 'Luas Lingkaran',
    description: 'Terima masukkan jari-jari dan cetak luas lingkarannya',
    content: `
      Kali ini, terimalah sebuah masukan dari pengguna berupa jari-jari lingkaran.<br>
      Cetaklah luas lingkaran berdasarkan jari-jari tersebut.<br><br>

      Blok <b>konstanta matematika</b> sudah tersedia di kategori Matematika. Gunakan konstanta &pi; untuk menghitung luas secara akurat.<br>
      <div class="text-center"><img src="/images/constant-block.jpg"/></div><br>
      <h2>Tips</h2>
      Gunakan blok <b>operator</b> untuk mengalikan dua buah nilai.<br>
      Kamu bisa memasukan blok operator ke dalam blok operator lain untuk menghitung nilai yang lebih kompleks.
      <div class="text-center"><img src="/images/operator-blocks.jpg"/></div><br>
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [3.88], output: [47.29479244420218] },
      { input: [10], output: [314.1592653589793] },
      { input: [1234], output: [4783879.062809778] },
    ]
  },
  {
    lessonsId: 3,
    subLessonsId: 1,
    name: 'Jika Ini, Maka Itu',
    description: 'Cetak kembali angka apabila merupakan bilangan ganjil',
    content: `
      <div class="flex align-items-center">
        <div class="image-fit">
          <img src="/images/if-block.jpg"/>
        </div>
        <div class="ml-1">
          Memperkenalkan blok <b>if</b>.<br><br>
          Blok ini akan mengeksekusi rangkaian blok yang ada di dalam kurung jika kondisi di dalam segi enam bernilai benar.<br><br>
        </div>
      </div>
      Misal blok disusun seperti ini:
      <div class="text-center"><img src="/images/if-block-content.jpg"/></div>
      Maka teks "Var sama dengan 0" hanya tercetak apabila isi variabel <b>var</b> bernilai nol. <br><br>
      
      Sekarang tugasmu adalah, terima masukan nilai dari pengguna, lalu cetak kembali nilai apabila nilai adalah bilangan ganjil.<br>
      <b>Contoh:</b>
      <ul class="mb-1">
        <li>Jika masukan pengguna bernilai <b>16</b>, maka tidak akan mencetak apa-apa.</li>
        <li>Jika masukan pengguna bernilai <b>11</b>, maka akan mencetak angka 11 di konsol.</li>
      </ul>
      
      <h2>Tips</h2>
      Blok <b>uji logika angka</b> dapat diakses melalui kategori Matematika. Pilihlah uji logika yang tepat untuk kasus ini.
      <div class="text-center"><img src="/images/math-logic-block.jpg"/></div>
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [16], output: [] },
      { input: [11], output: [11] },
      { input: [24], output: [] },
      { input: [0], output: [] },
      { input: [9999], output: [9999] },
      { input: [13049121], output: [13049121] }
    ]
  },
  {
    lessonsId: 3,
    subLessonsId: 2,
    name: 'Percabangan Lanjut',
    description: 'Pisahlah bilangan positif, negatif, dan nol',
    content: `
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [0], output: ['nol'] },
      { input: [-1203], output: ['negatif'] },
      { input: [24], output: ['positif'] },
    ]
  },
  {
    lessonsId: 3,
    subLessonsId: 3,
    name: 'Kasus Bilangan',
    description: 'Pisahlah bilangan positif genap, positif ganjil, negatif, dan nol',
    content: `
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [1234125], output: ['positif ganjil'] },
      { input: [12031294], output: ['positif genap'] },
      { input: [0], output: ['nol'] },
      { input: [-1231245], output: ['negatif'] },
    ]
  },
  {
    lessonsId: 4,
    subLessonsId: 1,
    name: 'Hukuman Guru',
    description: 'Gunakanlah repeat untuk mengulang kalimat',
    content: `
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: ['abcde', 9], output: ['abcde', 'abcde', 'abcde', 'abcde', 'abcde', 'abcde', 'abcde', 'abcde', 'abcde'] },
      { input: ['asfadsfasfd', 0], output: [] },
      { input: ['podsfpaospf', 4], output: ['podsfpaospf', 'podsfpaospf', 'podsfpaospf', 'podsfpaospf'] },
    ]
  },
  {
    lessonsId: 4,
    subLessonsId: 2,
    name: 'Deret Aritmatika',
    description: 'Hitunglah deret aritmatika 1, 2, 3, sampai suku ke-n',
    content: `
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [0], output: [0] },
      { input: [1], output: [1] },
      { input: [2], output: [3] },
      { input: [4], output: [10] },
      { input: [6], output: [21] },
      { input: [8], output: [36] },
      { input: [100], output: [5050] },
    ]
  },
  {
    lessonsId: 4,
    subLessonsId: 3,
    name: 'Deret Aritmatika 2',
    description: 'Hitunglah deret aritmatika 1, 4, 7, sampai batas masukan',
    content: `
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [0], output: [0] },
      { input: [1], output: [1] },
      { input: [2], output: [1] },
      { input: [7], output: [12] },
      { input: [29], output: [145] },
      { input: [39], output: [247] },
      { input: [49], output: [425] },
    ]
  },
  {
    lessonsId: 4,
    subLessonsId: 4,
    name: 'Dua Pangkat',
    description: 'Periksalah apakah masukan merupakan bilangan "dua pangkat"',
    content: `
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [1], output: [true] },
      { input: [2], output: [true] },
      { input: [63], output: [false] },
      { input: [0], output: [false] },
      { input: [128], output: [true] },
      { input: [65536], output: [true] },
    ]
  },
  {
    lessonsId: 5,
    subLessonsId: 1,
    name: 'Cetak Elemen List',
    description: 'Cetak elemen indeks ke-i dari list ke konsol',
    content: `
      Bikin list isinya, ayam, ikan, sapi, kambing. Cetak elemen ke-i, dengan i merupakan masukan dari pengguna.
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="List" colour="260">
          <label text="Buat list" web-class="toolbox-label"/>
          <block type="lists_create_with">
              <mutation items="0"></mutation>
          </block>
          <block type="lists_create_with"></block>
          <block type="lists_repeat">
              <value name="NUM">
                  <shadow type="math_number">
                      <field name="NUM">5</field>
                  </shadow>
              </value>
          </block>
          <label text="Operasi list" web-class="toolbox-label"/>
          <block type="lists_getIndex">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [0], output: ['ayam'] },
      { input: [1], output: ['ikan'] },
      { input: [2], output: ['sapi'] },
      { input: [3], output: ['kambing'] },
    ]
  },
  {
    lessonsId: 5,
    subLessonsId: 2,
    name: 'Cetak List',
    description: 'Buat sebuah list dan cetak satu persatu isinya',
    content: `
      Pake blok pengulangan untuk menyelesaikan masalah
      Nambah satu blok forEach buat list
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <block type="controls_forEach"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="List" colour="260">
          <label text="Buat list" web-class="toolbox-label"/>
          <block type="lists_create_with">
              <mutation items="0"></mutation>
          </block>
          <block type="lists_create_with"></block>
          <block type="lists_repeat">
              <value name="NUM">
                  <shadow type="math_number">
                      <field name="NUM">5</field>
                  </shadow>
              </value>
          </block>
          <label text="Operasi list" web-class="toolbox-label"/>
          <block type="lists_length"></block>
          <block type="lists_getIndex">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
          <block type="lists_setIndex">
            <value name="LIST">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [1, '1'], output: ['1'] },
      { input: [5, '1', '2', '3', '4', '5'], output: ['1', '2', '3', '4', '5'] },
      { input: [0], output: [] },
      { input: [10, '1', '1', '1', '1', '1', '1', '1', '1', '1', '1'], output: ['1', '1', '1', '1', '1', '1', '1', '1', '1', '1'] },
    ]
  },
  {
    lessonsId: 5,
    subLessonsId: 3,
    name: 'Cetak List 2',
    description: 'Buat sebuah list dan cetak satu persatu dari indeks tertinggi',
    content: `
    Nambah blok logika empty di list
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <block type="controls_forEach"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="List" colour="260">
          <label text="Buat list" web-class="toolbox-label"/>
          <block type="lists_create_with">
              <mutation items="0"></mutation>
          </block>
          <block type="lists_create_with"></block>
          <block type="lists_repeat">
              <value name="NUM">
                  <shadow type="math_number">
                      <field name="NUM">5</field>
                  </shadow>
              </value>
          </block>
          <label text="Uji logika list" web-class="toolbox-label"/>
          <block type="lists_isEmpty"></block>
          <label text="Operasi list" web-class="toolbox-label"/>
          <block type="lists_length"></block>
          <block type="lists_getIndex">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
          <block type="lists_setIndex">
            <value name="LIST">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
      </xml>
    `,
    testCase: [
      { input: [1, 'a'], output: ['a'] },
      { input: [0], output: [] },
      { input: [3, 'a', 'b', 'c'], output: ['c', 'b', 'a'] },
      { input: [5, 'a', 'b', 'c', 'd', 'e'], output: ['e', 'd', 'c', 'b', 'a'] },
      { input: [3, '10', '11', '12'], output: ['12', '11', '10'] },
    ]
  },
  {
    lessonsId: 6,
    subLessonsId: 1,
    name: 'Pangkat Lima',
    description: 'Buatlah fungsi yang menghitung pangkat lima',
    content: `
      Buatlah fungsi yang menghitung pangkat lima dari sebuah bilangan.<br>
      Di soal ini, kamu diminta untuk menerima <b>tiga buah bilangan</b> lalu mencetak nilai <b>pangkat limanya</b> di konsol.<br><br>
      
      <b>Contoh:</b> Misal masukan pengguna adalah <b>1</b>, <b>2</b>, dan <b>3</b>, maka keluaran di konsolnya akan menjadi:
      <p>
        <code>
          1<br>
          32<br>
          243
        </code>
      </p><br>
      
      Perhatikan bahwa di soal ini, kamu hanya dibatasi untuk menggunakan <b>maksimum 30 blok</b>.
    `,
    maxBlocks: 30,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="List" colour="260">
          <label text="Buat list" web-class="toolbox-label"/>
          <block type="lists_create_with">
              <mutation items="0"></mutation>
          </block>
          <block type="lists_create_with"></block>
          <block type="lists_repeat">
              <value name="NUM">
                  <shadow type="math_number">
                      <field name="NUM">5</field>
                  </shadow>
              </value>
          </block>
          <label text="Uji logika list" web-class="toolbox-label"/>
          <block type="lists_isEmpty"></block>
          <label text="Operasi list" web-class="toolbox-label"/>
          <block type="lists_length"></block>
          <block type="lists_getIndex">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
          <block type="lists_setIndex">
            <value name="LIST">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
        <category name="Fungsi" colour="290" custom="PROCEDURE"></category>
      </xml>
    `,
    testCase: [
      { input: [3, -5, 1], output: [243, -3125, 1], },
      { input: [1, 10, 100], output: [1, 100000, 10000000000], },
      { input: [0, -1, -2], output: [0, -1, -32], },
      { input: [-5, 1, 4], output: [-3125, 1, 1024], },
      { input: [-24, 0, -4], output: [-7962624, 0, -1024], },
    ]
  },
  {
    lessonsId: 6,
    subLessonsId: 2,
    name: 'Komposisi Fungsi',
    description: 'Buatlah fungsi x² + 1 dan komposisikan',
    content: `
      Adam sedang memikirkan berapakah hasil dari f(f(f(f(f(x))))) jika f(x) = x² + 1, dan x = 1.<br>
      Bantulah Adam menghitung hasil dari komposisi fungsi tersebut!<br><br>
      
      Program akan menerima dua buah angka, yaitu <b>x</b> dan <b>n</b>. <b>x</b> menyatakan nilai x di fungsi dan <b>n</b> menyatakan berapa kali fungsi tersebut akan dikomposisi.<br><br>
      <b>Contoh:</b> Pengguna memasukkan angka 2 dan 3, berarti program diminta untuk menghitung f(f(f(2))), yaitu:<br><br>
      ((2² + 1)² + 1)² + 1 = 677<br><br>
      Maka program akan mencetak angka <b>677</b>.<br><br>
      
      <h2>Tips</h2>
      Buatlah fungsi terpisah untuk menghitung hasil kuadrat dari bilangan.<br>Jangan lupa juga apabila n = 0 maka hasilnya selalu 0, berapapun x-nya.
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <block type="controls_forEach"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <block type="math_constant"></block>
          <label text="Operasi aritmatika" web-class="toolbox-label"/>
          <block type="math_arithmetic">
            <value name="A">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="B">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="List" colour="260">
          <label text="Buat list" web-class="toolbox-label"/>
          <block type="lists_create_with">
              <mutation items="0"></mutation>
          </block>
          <block type="lists_create_with"></block>
          <block type="lists_repeat">
              <value name="NUM">
                  <shadow type="math_number">
                      <field name="NUM">5</field>
                  </shadow>
              </value>
          </block>
          <label text="Uji logika list" web-class="toolbox-label"/>
          <block type="lists_isEmpty"></block>
          <label text="Operasi list" web-class="toolbox-label"/>
          <block type="lists_length"></block>
          <block type="lists_getIndex">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
          <block type="lists_setIndex">
            <value name="LIST">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
        <category name="Fungsi" colour="290" custom="PROCEDURE"></category>
      </xml>
    `,
    testCase: [
      { input: [0, 5], output: [677], },
      { input: [1, 0], output: [0], },
      { input: [1, 5], output: [458330], }
    ]
  },
  {
    lessonsId: 7,
    subLessonsId: 1,
    name: 'Uji Palindrom',
    description: 'Cetak true jika teks masukan merupakan palindrom',
    content: `
      Palindrom adalah teks yang dapat dibaca secara bolak balik, karena ketika dibalik teksnya tetap sama, misalnya seperti kata 'kayak', 'racecar', dan 'malam'.<br><br>
      Sekarang, buatlah program yang mencetak <b>true</b> apabila teks masukan pengguna merupakan <b>palindrom</b>, dan false jika tidak.<br><br>
      
      <b>Contoh: </b>
      <ul>
        <li>Misalnya pengguna memberi masukan <code>'abcba'</code>, maka di konsol akan tercetak <code>true</code></li>
        <li>Misalnya pengguna memberi masukan <code>'padam'</code>, maka di konsol akan tercetak <code>false</code> karena 'padam' jika dibalik menjadi 'madap'</li>
      </ul><br>
      <b>Catatan:</b> Gunakan blok <b>true/false</b> yang terdapat di kategori <b>Logika</b> ketika ingin mencetak nilai true atau false ke konsol.<br>
      <div class="text-center">
        <img class="image-fit" src="/images/true-block.jpg"/>
      </div>
    `,
    toolbox: `
      <xml id="toolbox" style="display: none">
        <category name="Logika" colour="210">
          <label text="Blok kondisional" web-class="toolbox-label"/>
          <block type="controls_if"></block>
          <label text="Ekspresi logika" web-class="toolbox-label"/>
          <block type="logic_compare"></block>
          <block type="logic_operation"></block>
          <block type="logic_negate"></block>
          <block type="logic_boolean"></block>
          <label text="Null dan operator ternary" web-class="toolbox-label"/>
          <block type="logic_null"></block>
          <block type="logic_ternary"></block>
        </category>
        <category name="Pengulangan" colour="120">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
          <block type="controls_whileUntil"></block>
          <block type="controls_for">
            <value name="FROM">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
            <value name="TO">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
            <value name="BY">
              <shadow type="math_number">
                <field name="NUM">1</field>
              </shadow>
            </value>
          </block>
          <block type="controls_forEach"></block>
          <label text="Lompat dari pengulangan" web-class="toolbox-label"/>
          <block type="controls_flow_statements"></block>
        </category>
        <category name="Matematika" colour="230">
          <label text="Angka dan konstanta" web-class="toolbox-label"/>
          <block type="math_number"></block>
          <label text="Uji logika angka" web-class="toolbox-label"/>
          <block type="math_number_property">
            <value name="NUMBER_TO_CHECK">
              <shadow type="math_number">
                <field name="NUM">0</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="Teks" colour="160">
          <label text="Teks" web-class="toolbox-label"/>
          <block type="text"></block>
          <label text="Masukan dan keluaran" web-class="toolbox-label"/>
          <block type="text_print">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">Masukkan nilai:</field>
              </shadow>
            </value>
          </block>
        </category>
        <category name="List" colour="260">
          <label text="Buat list/teks dari list" web-class="toolbox-label"/>
          <block type="lists_create_with">
              <mutation items="0"></mutation>
          </block>
          <block type="lists_split">
            <value name="DELIM">
              <shadow type="text">
                <field name="TEXT">,</field>
              </shadow>
            </value>
          </block>
          <label text="Uji logika list" web-class="toolbox-label"/>
          <block type="lists_isEmpty"></block>
          <label text="Operasi list" web-class="toolbox-label"/>
          <block type="lists_length"></block>
          <block type="lists_getIndex">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
          <block type="lists_setIndex">
            <value name="LIST">
              <block type="variables_get">
                <field name="VAR">listVar</field>
              </block>
            </value>
          </block>
        </category>
        <sep/>
        <category name="Variabel" colour="330" custom="VARIABLE"></category>
        <category name="Fungsi" colour="290" custom="PROCEDURE"></category>
      </xml>
    `,
    testCase: [
      { input: ['aaa'], output: [true] },
      { input: [''], output: [true] },
      { input: ['kayak'], output: [true] },
      { input: ['loss'], output: [false] },
      { input: ['abcdefghgfedcbb'], output: [false] },
      { input: ['abibubebobebubiba'], output: [true] },
      { input: ['abcdefggfedcba'], output: [true] },
      { input: ['abcdefghiigfedcba'], output: [false] },
      { input: ['palindrom'], output: [false] },
      { input: ['abcdefghijklmnopqrstuvwxyz0123456789876543210zyxwvutsrqponmlkjihgfedcba'], output: [true] },
    ]
  },
]

export default LessonsContent
